export class AppAPI {
  constructor(req) {
    this.req = req;
  }

  async getApp(app_id) {
    return this.req.get({
      url: `/api/app/get`,
      params: {
        app_id: app_id,
      },
    });
  }
};
